import { render, staticRenderFns } from "./EventStats.vue?vue&type=template&id=db246456&scoped=true&"
import script from "./EventStats.vue?vue&type=script&lang=js&"
export * from "./EventStats.vue?vue&type=script&lang=js&"
import style0 from "./EventStats.vue?vue&type=style&index=0&id=db246456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db246456",
  null
  
)

export default component.exports